import { getUrlApi } from "../utilities/util";
import ApiHandler from "./ApiHandlers/ApiHandler";

export const baseURL = String(getUrlApi());

export default class FamilyApi {

    static async CreateFamily(data: { name: string; description: string; plantId: string }): Promise<any> {
        const response = await ApiHandler(baseURL).post("/Family/Create", data);
        return response.data;
    };

    static async GetAllFamilies(): Promise<any> { 
      const response = await ApiHandler(baseURL).get("/Family/GetAll");
      return response.data;
    }

    static async GetFamiliesByFilterAsync(
    plantIds: string[],
    pageNumber: number = 1,
    pageSize: number = 10,
    sortField: string = "name",
    sortDirection: string = "asc",
    code?: string,
    name?: string,
    description?: string
  ): Promise<any> {
    let url = `/family/getbyfilterasync?`;
    plantIds.forEach((id) => {
      url += `plantIds=${encodeURIComponent(id)}&`;
    });
    url += `pageNumber=${pageNumber}&pageSize=${pageSize}`;
    url += `&sortField=${encodeURIComponent(sortField)}`;
    url += `&sortDirection=${encodeURIComponent(sortDirection)}`;

    if (code) url += `&code=${code}`;
    if (name) url += `&name=${name}`;
    if (description) url += `&description=${encodeURIComponent(description)}`;
    if (code) url += `&code=${code}`;

    return ApiHandler(baseURL).get(url);
  }

  static async DeleteFamily(id: string): Promise<any> {
      const response = await ApiHandler(baseURL).post(`/Family/Delete?Id=${id}`);
      return response;
  }

  static async UpdateFamily(data: {
  id: string;
  name: string;
  description: string;
  }): Promise<any> {
    const response = await ApiHandler(baseURL).post("/Family/Update", data);
    return response.data;
  }

  static async GetById(id: any): Promise<any> {
      const response = await ApiHandler(baseURL).get(`/Family/GetById?Id=${id}`);
      return response;
  }

  static async AssignToLine(payload: { lineId: string; familyIds: string[] }): Promise<any> {
      return ApiHandler(baseURL).put("/Family/AssignToLine", payload);
    }

  static async RemoveFromLine(payload: { lineId: string; familyIds: string[] }): Promise<any> {
    return ApiHandler(baseURL).put("/Family/RemoveFromLine", payload);
  }

  static async GetFamiliesByLine(lineId: string): Promise<any> {
    return ApiHandler(baseURL).get(`/Family/GetByLine/${encodeURIComponent(lineId)}`);
  }
  
  static async GetFamiliesByPlant(plantId: string): Promise<any> {
    return ApiHandler(baseURL).get(`/Family/GetByPlant/${encodeURIComponent(plantId)}`);
  }
}

